
import { Region } from '@/data/types/region-types';
import { useLanguage } from '@/contexts/language';
import { Users, UserCheck, MapPin } from 'lucide-react';

interface RegionStatsProps {
  region: Region;
}

const RegionStats: React.FC<RegionStatsProps> = ({ region }) => {
  const { t } = useLanguage();

  return (
    <div className="space-y-3 mb-4 p-2 bg-gray-50 rounded-md">
      <div className="text-gray-700 font-medium mb-1">{t('regionStats')}</div>
      
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <Users className="h-4 w-4 mr-2 text-gray-500" />
          <span className="text-sm font-medium text-gray-700">{t('missionaries')}</span>
        </div>
        <span className="text-sm font-semibold">{region.missionaries}</span>
      </div>
      
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <UserCheck className="h-4 w-4 mr-2 text-gray-500" />
          <span className="text-sm font-medium text-gray-700">{t('unreachedPeoples')}</span>
        </div>
        <span className="text-sm font-semibold">{region.unreached_population?.toLocaleString() || 0}</span>
      </div>
      
      {region.church_funding && region.church_funding.length > 0 && (
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <MapPin className="h-4 w-4 mr-2 text-gray-500" />
            <span className="text-sm font-medium text-gray-700">{t('churchesSupported')}</span>
          </div>
          <span className="text-sm font-semibold">{region.church_funding.length}</span>
        </div>
      )}
    </div>
  );
};

export default RegionStats;
